import React from 'react'
import CheckboxDocuments from './CheckboxDocuments'
import _ from 'lodash'
import NullMssg from '../../../common/NullMssg'
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'

const DocumentsOfAProductByType = ({
  docs,
  allTypesOfDocuments,
  selectedPDF, // pdf seleccionado para poder visualizarlo
  //parms presentacion
  idPresentation,
  docsInPresentation,
  onlyViewDocsProduct,
  selectDocumentsToAddToPresentation, // añadir a la lista aquellos documentos del producto que queremos añadir a la presentacion
}) => {
  // Funcion que devuelve un boolean en funcion si el documento ya esta incluido en la presentacion
  const isTheDocumentIncludedInThePresentation = (doc) => {
    return docsInPresentation.some(
      (x) => x.id_ArticuloDocumento === doc.id_ArticuloDocumento,
    )
  }

  // tipos de documentos que tiene el producto final ordenados por prioridad
  const typeOfDocHasFinalProduct = _.orderBy(
    allTypesOfDocuments.filter((typeDoc) =>
      docs.some((doc) => typeDoc.id_TipoDocumentos == doc.id_TipoDocumento),
    ),
    ['nr_Prioridad'],
    ['asc'],
  )

  return (
    <div className='documents-container'>
      {typeOfDocHasFinalProduct.length > 0 ? (
        typeOfDocHasFinalProduct.map((typeDocuments) => (
          <Accordion
            key={typeDocuments.id_TipoDocumentos}
            className='document-accordion'
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls={`panel-${typeDocuments.id_TipoDocumentos}-content`}
              id={`panel-${typeDocuments.id_TipoDocumentos}-header`}
              className='document-accordion__header'
            >
              <Typography className='document-accordion__title'>
                {typeDocuments.nombre}
              </Typography>
            </AccordionSummary>
            <AccordionDetails className='document-accordion__details'>
              <div className='document-accordion__content'>
                {docs.length > 0
                  ? docs
                      .filter(
                        (doc) =>
                          doc.id_TipoDocumento ===
                          typeDocuments.id_TipoDocumentos,
                      )
                      .map((doc) => (
                        <div
                          className='document-item'
                          key={doc.id_ArticuloDocumento}
                        >
                          <div className='document-item__content'>
                            {idPresentation !== undefined &&
                              !onlyViewDocsProduct && (
                                <CheckboxDocuments
                                  isTheDocumentIncludedInThePresentation={
                                    isTheDocumentIncludedInThePresentation
                                  }
                                  doc={doc}
                                  selectDocumentsToAddToPresentation={
                                    selectDocumentsToAddToPresentation
                                  }
                                  idPresentation={idPresentation}
                                />
                              )}
                            <button
                              className='document-item__button'
                              onClick={(e) => selectedPDF(e, doc)}
                            >
                              {doc.nombreDocumento}
                            </button>
                          </div>
                        </div>
                      ))
                  : null}
              </div>
            </AccordionDetails>
          </Accordion>
        ))
      ) : (
        <div className='no-documents'>
          <NullMssg mssg={'No hay documentos adjuntos'} />
        </div>
      )}
    </div>
  )
}

export default DocumentsOfAProductByType
